
    import {Component, Inject, Vue, Prop} from 'vue-property-decorator';
    import {Validator} from 'vee-validate';

    @Component({
        props: {
            placeholder: String,
            icon: String,
            type: String,
            name: String,
            rules: String,
            value: String,
            label: String,
        },
    })
    export default class InputText extends Vue {
        @Inject('$validator') public $validator!: Validator;
    }
